<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card :title="'WORK ORDER TIMES'" class="">
        <div id="work-order-times-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="mappedTimesList">
              <template slot="thead">
                <vs-th width="20%">FG TYPE</vs-th>
                <vs-th width="15%">CLEAN TIME (H:i)</vs-th>
                <vs-th width="15%">MACHINE TIME (H:i)</vs-th>
                <vs-th width="15%">LABOUR TIME (H:i)</vs-th>
                <vs-th width="25%">NOTES</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_type" class="capitalize">
                    {{ data[indextr].formulation_type }}
                  </vs-td>

                  <vs-td :data="data[indextr].clean_time">
                    {{ data[indextr].clean_time }}
                  </vs-td>

                  <vs-td :data="data[indextr].machine_time">
                    {{ data[indextr].machine_time }}
                  </vs-td>

                  <vs-td :data="data[indextr].labour_time">
                    {{ data[indextr].labour_time }}
                  </vs-td>

                  <vs-td :data="data[indextr].note">
                    <vx-read-more :length="100" :text="data[indextr].note" />
                  </vs-td>

                  <vs-td>
                    <div class="justify-start vx-row" v-can="'edit-work-order-manufacturing-setting'">
                      <vx-tooltip v-if="data[indextr].exists" text="Update Times" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].formulation_type, data[indextr].id)" class="ml-3" size="small"
                          color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vs-button v-else @click.stop="onClickAdd(data[indextr].formulation_type)" class="ml-3" size="small"
                        color="primary" type="filled" icon-pack="feather" icon="icon-plus">Add Times</vs-button>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <add-new-work-order-time-pop-up ref="addNewWorkOrderTimePopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewWorkOrderTimePopUp from '@/components/popups/settings/manufacturing-finance/AddNewWorkOrderTimePopUp.vue';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const SettingsRepository = RepositoryFactory.get('settings');

export default {
  name: "ManufacturingFinanceSettings",
  data() {
    return {
      work_order_times: [],
      types: ['powder', 'liquid', 'spray dry powder', 'fruit']
    }
  },
  components: {
    AddNewWorkOrderTimePopUp
  },
  computed: {
    mappedTimesList() {
      return this.types.map(type => {
        const found = this.work_order_times.find(item => item.formulation_type === type);
        if (found) {
          return {
            id: found.id,
            formulation_type: found.formulation_type,
            clean_time: found.clean_time ? found.clean_time.substring(0, 5) : '-',
            machine_time: found.machine_time ? found.machine_time.substring(0, 5) : '-',
            labour_time: found.labour_time ? found.labour_time.substring(0, 5) : '-',
            note: found.note || '-',
            exists: true
          };
        }
        return {
          id: null,
          formulation_type: type,
          clean_time: '-',
          machine_time: '-',
          labour_time: '-',
          note: '-',
          exists: false
        };
      });
    }
  },
  methods: {
    async refreshData() {
      await this.fetchWorkOrderTimes()
    },
    async fetchWorkOrderTimes() {
      await this.$vs.loading({
        container: '#work-order-times-table',
        scale: 0.45
      })
      try {
        const { data } = (await SettingsRepository.getWorkOrderTimes()).data
        this.work_order_times = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#work-order-times-table > .con-vs-loading')
    },
    async onClickAdd(formulationType) {
      await this.$refs.addNewWorkOrderTimePopUp.openPopup(formulationType)
    },
    async onClickUpdate(formulationType, id) {
      await this.$refs.addNewWorkOrderTimePopUp.openPopup(formulationType, id)
    }
  },
  async mounted() {
    await this.fetchWorkOrderTimes()
  },
  mixins: [SuccessMessage, ErrorMessages]
}
</script>

<style scoped></style>
